<template>
  <div class="app">
    <div class="title">COMPANY INTRODUCTION</div>
    <div class="title">公司介绍</div>
    <div style="line-height:30px">
          山东大课堂信息科技有限公司成立于2016年，总部位于山东济南，是集教育电子产品研发销售、软件研发、智慧教育应用平台、教育资源于一体的高新技术企业。致力于打造教育产业生态链，是国内知名的教育信息化资源服务提供商，教育信息化基础设施服务商。
      山东大课堂科技有限公司以创新设计为抓手，以智能化教育装备为核心，打造集研发设计、产业孵化、互动体验、人才交流、教育培训于一体的现代教育装备“智造”全产业链模式，先后已获得21项软著，4项专利。旗下孺教网智慧教育应用平台打造是以“促进优质教育资源共享、优化网络空间学习环境”为目标,
      专注教育信息化技术与教师“教”、学生“学”的深度融合，充分优化教师教学、学生学习的各个环节，助力常态课堂教学环境，在不打破教学“传到授业解惑”的教育本质基础上，打造以资源、互动为核心的高效教学智慧课堂。目前，孺教网已为全国25个省市区，400余地级市，10000所学校安装提供智慧教育综合解决方案，为当地学校师生有效推进教育信息化工作。
      公司坚持运用先进的管理理念，强化服务观念，优化教育产业，受到社会领导的一致好评。目前，已成为“中国教育装备行业协会会员单位”、“山东省教育装备行业协会会员单位”、“山东省工商联会员单位企业”、“高新区新的社会阶层人士统战工作实践创新基地”、并评获“山东民营企业公益之星”、“高新区五星级党组织”、“助力教育信息化共建单位”等多项社会荣誉。
    </div>
    <div style="text-align:center;"><img src="../../assets/code.jpg" alt="" style="width:160px"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.app {
  background-color: #fff;
  min-height: 500px;
  padding: 30px 50px;
  .title {
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    margin-bottom: 10px;
  }
}
</style>